import type {IModuloBase} from "../../../root/modulo";
import type {ModuloRedaccionUltimas} from "./modules";
import ModuloRedaccionUltimasRAM from "./modules/ram";
import ModuloRedaccionUltimasNews from "./modules/news";

class ModuloRedaccionUltimasBuilder {
    /* STATIC */
    public static async build(cfg: IModuloBase): Promise<ModuloRedaccionUltimas[]> {
        const salida: ModuloRedaccionUltimas[] = [];
        if (cfg.global.cfg.news.enabled) {
            salida.push(...ModuloRedaccionUltimasNews.buildArticulo(cfg));
            salida.push(...ModuloRedaccionUltimasNews.buildGeneral(cfg));
            salida.push(...ModuloRedaccionUltimasNews.buildLocalidad(cfg));
            if (cfg.global.cfg.news.ram) {
                salida.push(...ModuloRedaccionUltimasRAM.buildArticulo(cfg));
                salida.push(...ModuloRedaccionUltimasRAM.buildGeneral(cfg));
            }
        }

        return salida;
    }
}

export default ModuloRedaccionUltimasBuilder;
